module.exports = __webpack_public_path__ + "img/image01_sp.c42283bd.jpg";